/* eslint-disable react/display-name */
import React from "react";
import PropTypes from "prop-types";
import { LinkContainer } from "react-router-bootstrap";
import { IoFolder, IoTrash, IoEllipsisVertical } from "react-icons/io5";
import { DropdownButton, NavItem } from "react-bootstrap";
import isEmpty from "lodash/isEmpty";

import ReactTable from "react-table";
import ResponsiveDataComponent from "../../common/ResponsiveDataComponent";
import Loading from "../../common/Loading";

const CallPartsList = ({ call, onClickEdit, onClickDelete, isMobile }) => {
  const columns = !isMobile
    ? [
        {
          Header: "Description",
          accessor: "item_description"
        },
        {
          Header: "Quantity",
          accessor: "item_qty",
          Cell: (row) => row.value || "--"
        },
        {
          Header: "Cost",
          accessor: "item_cost"
        },
        {
          Header: "Billable",
          accessor: "item_bill"
        }
      ]
    : [
        {
          Header: "Description",
          accessor: "item_description"
        }
      ];

  columns.push({
    Header: "",
    accessor: "_id",
    maxWidth: 80,
    filterable: false,
    sortable: false,
    // eslint-disable-next-line react/display-name
    Cell: (row) => (
      <div className="text-center actions">
        <DropdownButton
          title={
            <span>
              <IoEllipsisVertical />
            </span>
          }
          id="dropdown"
        >
          {onClickEdit && (
            <NavItem onClick={() => onClickEdit(row.value)}>
              <IoFolder />
              View
            </NavItem>
          )}
          {!onClickEdit && (
            <LinkContainer to={`/app/calls/${row.value}`}>
              <NavItem>
                <IoFolder />
                View
              </NavItem>
            </LinkContainer>
          )}
          <NavItem onClick={() => onClickDelete(row.value)}>
            <IoTrash className="brand-color" />
            Delete
          </NavItem>
        </DropdownButton>
      </div>
    )
  });

  const isLoading = !isEmpty(call) && !call.parts?.length;

  return (
    <ReactTable
      className="-highlight"
      data={call.parts}
      columns={columns}
      LoadingComponent={() => <Loading active={isLoading} />}
      showPagination
      defaultPageSize={10}
      SubComponent={
        isMobile
          ? (row) => (
              <ResponsiveDataComponent
                data={[
                  { key: "Description", label: row.original.description },
                  { key: "Quantity", label: row.original.item_qty },
                  {
                    key: "Cost",
                    label: row.original.item_cost
                  },
                  { key: "Is Billable", label: row.original.item_bill }
                ]}
              />
            )
          : false
      }
    />
  );
};

CallPartsList.propTypes = {
  onClickEdit: PropTypes.func,
  onClickDelete: PropTypes.func.isRequired,
  call: PropTypes.object.isRequired,
  isMobile: PropTypes.bool
};

export default CallPartsList;
